import { render, staticRenderFns } from "./MoleculePackage.vue?vue&type=template&id=2d0c1dab&scoped=true&"
import script from "./MoleculePackage.vue?vue&type=script&lang=js&"
export * from "./MoleculePackage.vue?vue&type=script&lang=js&"
import style0 from "./MoleculePackage.vue?vue&type=style&index=0&id=2d0c1dab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c1dab",
  null
  
)

export default component.exports